import SessionHelper from "../Helper/SessionHelper";

class LocationListRequest {
    LocationListURL(){
        return process.env.REACT_APP_BASEURL+"GetLocation";
    }
}
export const {LocationListURL}=new LocationListRequest();